<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form label-position="top"
             :model="dataForm"
             :rules="dataRule"
             ref="dataForm">
      <div class="location-layout">
        <el-row class="row-mar-l">
          <!-- 业务编码 -->
          <el-col :span="6">
            <el-form-item prop="bussinessTypeCode"
                          :label="$t('businessData.bussinessTypeCode')">
              <el-input v-model="dataForm.bussinessTypeCode"
                        :placeholder="$t('organization.orgCodeMessage')"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 业务名称 -->
          <el-col :span="6">
            <el-form-item prop="bussinessTypeName"
                          :label="$t('businessData.bussinessTypeName')">
              <el-input v-model="dataForm.bussinessTypeName"
                        :placeholder="$t('businessData.bussinessTypeName')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 排序 -->
          <el-col :span="6">
            <el-form-item prop="sort"
                          :label="$t('businessData.sort')">
              <el-input v-model="dataForm.sort"
                        :placeholder="$t('businessData.sort')"
                        @input="handleSort"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div style="margin-top: 20px">
      <!-- 保存 -->
      <el-button type="primary"
                 class="location-layout"
                 @click="dataFormSubmitHandle()">{{ $t('user.save') }}</el-button>
      <!-- 取消 -->
      <el-button type="button"
                 class="location-layout"
                 @click="back()">{{ $t('user.back') }}</el-button>
    </div>
  </el-card>
</template>
<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      dataForm: {
        bussinessTypeCode: '',
        bussinessTypeName: '',
        sort: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        bussinessTypeName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { max: 20, message: this.$t('validate.validateLength', { 'handle': '20' }), trigger: 'blur' },
          { validator: this.$validate.isSpecialCharacters, trigger: 'blur' }
        ],
        sort: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.initialization()
  },
  created () {
    this.$eventHub.$on(this.GLOBAL.BUSINESS_EDIT, (data) => {
      if (this.$refs.dataForm) {
        this.initialization()
      }
    })
  },
  methods: {
    // 页面初始化
    initialization () {
      this.$refs['dataForm'].resetFields()
      if (this.$route.query.bussinessTypeId && this.$route.query.bussinessTypeId !== '') {
        this.dataForm.bussinessTypeId = this.$route.query.bussinessTypeId
        this.getInfo()
      }
    },
    // 获取信息
    getInfo () {
      this.$request.get(`/sys/commbusinessdata/info/${this.dataForm.bussinessTypeId}`).then((res, total, code, data) => {
        this.dataForm = {
          ...this.dataForm,
          ...res
        }
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      let dataFormModify = { ...this.dataForm }
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$request.post(`/sys/commbusinessdata/${!dataFormModify.bussinessTypeId ? 'save' : 'update'}`,
          dataFormModify
        ).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.tabRemove(this.$store.state.contentTabsActiveName)
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      })
    }, 5000, { 'leading': true, 'trailing': false }),
    handleSort () {
      // eslint-disable-next-line no-useless-escape
      this.dataForm.sort = this.dataForm.sort.replace(/[^\.\d]/g, '')
      this.dataForm.sort = this.dataForm.sort.replace('.', '')
    },
    back () {
      this.$router.push({
        name: 'sys-businessdata'
      })
    },
    tabRemove (tabName) {
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: 'sys-businessdata'
        })
      }
    }
  }
}
</script>

<style type="text/css" scoped>
.row-mar-l {
  margin-bottom: 10px;
}
</style>
